import React from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';

/**
 * Límite de errores global. Evita que un fallo puntual (por ejemplo, uno
 * inducido por una extensión del navegador) tumbe toda la experiencia.
 * Muestra un mensaje en español con opción de recargar.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Silenciamos los errores conocidos de manipulación de DOM por extensiones.
    const msg = String(error?.message || '');
    if (msg.includes('removeChild') || msg.includes('insertBefore')) {
      // Auto-recuperación: forzamos re-render limpio.
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="dark min-h-screen grid place-items-center text-white p-6" style={{ background: '#07090A' }}>
          <div className="pp-glass p-8 max-w-md text-center" data-testid="error-boundary">
            <span className="w-12 h-12 rounded-2xl grid place-items-center mx-auto mb-4" style={{ background: 'rgba(201,168,76,0.15)' }}>
              <AlertTriangle size={22} className="pp-gold" />
            </span>
            <h1 className="text-xl font-bold mb-2">Se produjo un problema inesperado</h1>
            <p className="text-sm text-[#A6C3B4] mb-6">No te preocupes, tu información está a salvo. Recarga la vista para continuar.</p>
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              className="h-11 px-6 rounded-xl font-semibold text-[#07090A] inline-flex items-center gap-2"
              style={{ background: '#3EB489' }}>
              <RefreshCw size={16} /> Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
